import { render, staticRenderFns } from "./GroupTenant.vue?vue&type=template&id=205c6a2e&scoped=true"
import script from "./GroupTenant.vue?vue&type=script&lang=js"
export * from "./GroupTenant.vue?vue&type=script&lang=js"
import style0 from "./GroupTenant.vue?vue&type=style&index=0&id=205c6a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205c6a2e",
  null
  
)

export default component.exports